/**
 * Created by mauget on 2/3/16.
 */

// ControlSmallTextFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import propertyViewMapService from 'PropertyViewMapService.js';

import ControlModel    from 'ControlModel.js';
import SmallTextControlView  from 'common-visuals/SmallTextControlView.js';


//=============================================================================
//
// Creates a Large Heading control view, given a factoryService parameter key
// and a layout postion. The factory key defines the  initial rectangle of the
// control via a width and height from the factory parameter.
//
// -Lou Mauget, Feburary 3, 2016
//
//=============================================================================
class ControlSmallTextFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.styleColorText = '~smallTextColor';
        attributes.fontFamily = '~smallTextFont';
        attributes.fontSize = '~smallTextFont';
        attributes.textWeight = '~smallTextFont';
        attributes.textStyle = '~smallTextFont';
		attributes.inlineEditable = true;
        attributes.maxChars = '';
        attributes.resizePadding = 2;
        attributes.isHtml = false;
        attributes.text = 'Small Text';
		attributes.minWidth = 10;
        attributes.lowestHeight = 10;
        this.resolveForInitialMinHeight(attributes);
        attributes.translateProps = [
            {key:"text", label:"Text"},
            {key:"toolTip", label:"Tooltip"}
        ];

        const view = new SmallTextControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id} );

        return view;
    }

}

const controlSmallTextFactory = new ControlSmallTextFactory();

export default controlSmallTextFactory;
